import { render } from "./default.vue?vue&type=template&id=8a85fd52&scoped=true"
const script = {}

import "./default.vue?vue&type=style&index=0&id=8a85fd52&lang=scss&scoped=true"

import exportComponent from "/Users/alessiopracchia/Projects/innexta/bilanci/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a85fd52"]])

export default __exports__